/* 🤖 this file was generated by svg-to-ts */
export var spxIconTick = {
    name: 'tick',
    data: "<svg class=\"tick__outer\" xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\"><path class=\"tick__inner\" d=\"M3.75 10.875C3.75 10.875 4.875 10.875 6.375 13.5C6.375 13.5 10.5441 6.625 14.25 5.25\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>"
};
